/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/prefer-as-const */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-misused-promises */

import React from 'react';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Button, Divider, IconButton, MobileStepper, Paper, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import Snackbar from '@mui/material/Snackbar';
import { useSelector } from 'react-redux';
import { useTypedDispatch } from '../../redux/dispatchActionTypes/dispatchAndThunkActionTypes';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useParams } from 'react-router';
import { fetchInstallerEmailAlerts, fetchInstallerEmailAlertsArray, fetchReportGroups, fetchZoneMonitoringList, fetchZoneMonitoringListAfterRefresh, putInstallerEmailAlerts, putZonesExcludingFromMonitoring } from '../../redux/actions/specificPanelActions';
import { ReportGroupsProps } from '../ARCAccessModal/ARCAccessProps';
import { useTranslation, Trans } from 'react-i18next';
import ZonesMoniteringList from './ZonesMoniteringList';
import RefreshIcon from '@mui/icons-material/Refresh';
import { ZoneMonitoringArrayProps, ZoneMonitoringProps } from './ZonesMoniteringListTypes';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    overFlow: '',
    backgroundColor: 'background.paper',
    boxShadow: 20,
    p: 0,
};

type RemoteServingMonitoringProps = {
    open : boolean
    setOpen : (open:boolean) => void
}

export default function RemoteServicingMonitoringModal({ open, setOpen }: RemoteServingMonitoringProps): JSX.Element {
    const theme = useTheme();
    const md = useMediaQuery(theme.breakpoints.down('md'));
    const dispatch = useTypedDispatch();
    const { specificPanel,  alerts, zonesList, zoneListModifiedStatus } = useSelector((state: any) => state.specificPanelAndEstateReducer);
    const [activeStep, setActiveStep] = React.useState(0);
    const [count, setCount] = React.useState(0);
    const [snackOpen, setSnackOpen] = React.useState(false);
    const [status, setStatus] = React.useState(false);
    const [message, setMessage] = React.useState('');
    const [availableGroups, setAvailableGroups] = React.useState<ZoneMonitoringArrayProps>([]);
    const { t } = useTranslation();

    const steps = [
        {
            component: <ZonesMoniteringList zones={zonesList} availableGroups={availableGroups} setAvailableGroups={setAvailableGroups} />,
        },
    ];

    React.useEffect(() => {
        if (status === true) {
            if (zoneListModifiedStatus === 200) {
                setMessage(`Zones list modified successfully`);
            } else if (zoneListModifiedStatus === 500) {
                setMessage(`${t('msg_internal_error')}`);
            } else if (zoneListModifiedStatus === 400) {
                setMessage(`${t('lbl_unauthorizedUser')}`);
            } else {
                setMessage(`${t('lbl_someError')}`);
            }
            setSnackOpen(true);
            setStatus(false);
        }
        dispatch(fetchZoneMonitoringList(specificPanel?.panelId))
    }, [open,count]);

    const handleClose = () => {
        setOpen(false);
        setActiveStep(0);
    };

    const handleSave = async() => {
        await dispatch(putZonesExcludingFromMonitoring(specificPanel?.panelId,availableGroups))
        setStatus(true)
        setOpen(false);
        setCount((prevCount) => prevCount + 1);
    };

    const handleRefresh = async() => {
        await dispatch(fetchZoneMonitoringListAfterRefresh(specificPanel?.panelId))
    };

    const handleSnackClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackOpen(false);
    };

    const action = (
        <React.Fragment>
            <Button color="primary" size="small" onClick={handleSnackClose}>
            {t('lbl_close')}
            </Button>
        </React.Fragment>
    );

    return (
        <div>
            {md ? (
                <>
                    <Modal open={open} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <Box
                            sx={{
                                position: 'absolute' as 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: '100%',
                                height: '100%',
                                backgroundColor: 'background.paper',
                                boxShadow: 20,
                                p: 0,
                            }}
                        >
                            <Paper elevation={0} sx={{ pb: 0 }}>
                                <Paper
                                    elevation={4}
                                    sx={{
                                        paddingTop: 2,
                                        paddingBottom: 1,
                                        paddingLeft: 2,
                                        paddingRight: 2,
                                        display: 'flex',
                                        flexDirection: 'row',
                                    }}
                                >
                                    <IconButton onClick={handleClose}>
                                        <ArrowBackIcon />
                                    </IconButton>
                                    &ensp;&ensp;
                                    <Typography sx={{ pt: 0.5 }} variant="h6">
                                    {'Remote Servicing activity monitoring'}
                                    </Typography>
                                </Paper>
                                <Divider />
                                <Paper elevation={0} sx={{ pl: 3, pr: 2, pt: 2, pb: 8,maxHeight: '90vh', overflow: 'auto' }}>
                                    {steps[activeStep].component}
                                </Paper>
                            </Paper>
                            <Divider />
                            <Paper>
                            <MobileStepper
                                    variant="dots"
                                    steps={0}
                                    position="static"
                                    activeStep={activeStep}
                                    sx={{
                                        position: 'fixed',
                                        top: '90%',
                                        transform: 'translateY(-100%)',
                                        width: '100%',
                                        p: 2,
                                        backgroundColor: 'inherit',
                                    }}
                                    nextButton={undefined}
                                    backButton={
                                        <Button fullWidth startIcon={<RefreshIcon />} size="small" variant="outlined" onClick={handleRefresh}>
                                        {'Refresh the list of zones'}
                                    </Button>
                                    }
                                />
                            </Paper>
                            <Divider />
                            <Paper>
                                <MobileStepper
                                    variant="dots"
                                    steps={0}
                                    position="static"
                                    activeStep={activeStep}
                                    sx={{
                                        position: 'fixed',
                                        top: '100%',
                                        transform: 'translateY(-100%)',
                                        width: '100%',
                                        p: 2,
                                        backgroundColor: 'inherit',
                                    }}
                                    nextButton={
                                        <Button disabled={zonesList.length === 0} size="medium" variant="contained" onClick={handleSave}>
                                            {t('btn_save')}
                                        </Button>
                                    }
                                    backButton={
                                        <Button size="small" variant="outlined" onClick={handleClose}>
                                            {t('btn_cancel')}
                                        </Button>
                                    }
                                />
                            </Paper>
                        </Box>
                    </Modal>
                    <Snackbar
                        open={snackOpen}
                        autoHideDuration={6000}
                        onClose={handleSnackClose}
                        message={message}
                        action={action}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    />
                </>
            ) : (
                <>
                    <Modal open={open} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <Box sx={style}>
                            <Paper
                                elevation={0}
                                sx={{ paddingTop: 2, paddingBottom: 3, paddingLeft: 3, paddingRight: 2 }}
                            >
                                <Typography variant="h6">{'Remote Servicing activity monitoring'}</Typography>
                                <Typography sx={{pt:2}} variant='body2'>
                                    Enabled zones will be monitored for activity in the 7 days prior to the report.
                                </Typography>
                            </Paper>
                            <Divider />
                            <Paper elevation={0} sx={{ pl: 3, pr: 2, pt: 2, pb: 2, maxHeight: 400, overflow: 'auto' }}>
                                {steps[activeStep].component}
                            </Paper>
                            <Divider />
                            <MobileStepper
                                variant="dots"
                                steps={0}
                                position="static"
                                activeStep={activeStep}
                                
                                sx={{
                                    maxWidth: 450,
                                    flexGrow: 1,
                                    paddingTop: 2,
                                    paddingBottom: 2,
                                    paddingLeft: 3,
                                    paddingRight: 3,
                                    backgroundColor: 'inherit',
                                }}
                                nextButton={undefined}
                                backButton={
                                    <Button fullWidth startIcon={<RefreshIcon />} size="small" variant="outlined" onClick={handleRefresh}>
                                        {'Refresh the list of zones'}
                                    </Button>
                                }
                            />
                            <Divider />
                            <MobileStepper
                                variant="dots"
                                steps={0}
                                position="static"
                                activeStep={activeStep}
                                sx={{
                                    maxWidth: 450,
                                    flexGrow: 1,
                                    paddingTop: 2,
                                    paddingBottom: 2,
                                    paddingLeft: 3,
                                    paddingRight: 3,
                                    backgroundColor: 'inherit',
                                }}
                                nextButton={
                                    <Button disabled={zonesList.length === 0} size="medium" variant="contained" onClick={handleSave}>
                                        {t('btn_save')}
                                    </Button>
                                }
                                backButton={
                                    <Button size="small" variant="outlined" onClick={handleClose}>
                                        {t('btn_cancel')}
                                    </Button>
                                }
                            />
                        </Box>
                    </Modal>
                    <Snackbar
                        open={snackOpen}
                        autoHideDuration={6000}
                        onClose={handleSnackClose}
                        message={message}
                        action={action}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    />
                </>
            )}
        </div>
    );
}
